import { NavigationService } from '@ispm/navigation/services/navigation.service';
import { ResourceTypes } from './interfaces';
import { TablelistStoreHandlerService } from './services/tablelist-store-handler.service';
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot} from "@angular/router";
import { PatientService } from '@ispm-client/modules/patient/services/patient.service';

@Injectable({providedIn: 'root'})
export class resolveWorklistItems {
  constructor(private navigationService: NavigationService) {
  }
  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    this.navigationService.navigationResourceType = activatedRouteSnapshot.params.identify;
  }
}

@Injectable({providedIn: 'root'})
export class resolveWorklistConfiguration {
  constructor(private navigationService: NavigationService,
              private tablelistStoreHandler: TablelistStoreHandlerService) {
  }
  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return this.tablelistStoreHandler.resolveConfigurationTemplate({
      resourceType: ResourceTypes.Generic,
      configTemplateType: activatedRouteSnapshot.params.type,
      transactionId: activatedRouteSnapshot.params.transactionId
    })
    .toPromise()
      .then(config => config);
  }
}

@Injectable({providedIn: 'root'})
export class resolveWorklistTabConfiguration {
  constructor() {
  }
  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return activatedRouteSnapshot.params.type;
  }
}

@Injectable({providedIn: 'root'})
export class resolveCurrentPatientIdentifierWorklist {
  constructor(
    private patientService: PatientService
  ) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return this.patientService.storeCurrentPatientAggIdentifiers(activatedRouteSnapshot.params.patientId).subscribe();
  }
}
